import PromoCardBlock from './PromoCardBlock.vue'

// Maps a Storyblok block's `component` name to the Vue component that renders
// it. Register every new nestable block here — StoryblokContent skips (and
// warns about) any block name it cannot resolve.
export const BLOCK_COMPONENTS = {
    'game-on-promo-card': PromoCardBlock,
}
